import { Injectable } from "@angular/core";
import gql from "graphql-tag";
import { Apollo } from "apollo-angular";
import { map, tap } from "rxjs/operators";
import { IGqlUserAvailabilityResponse, IGqlUserAvailabilityInput, IGqlBaseOptions } from '../interfaces';
import { ScheduleInformation } from "@microsoft/microsoft-graph-types";
import { Observable } from 'rxjs';
import { safeResolve } from "../rxjs";
import { buildWithoutConnectionQuery, connectionQuery } from "src/app/shared/modules/graphql/helpers.class";
import { IApiUserCalendarFilter, IApiUserCalendarsConnection } from "src/app/shared/modules/graphql/types/types";

@Injectable()
export class GqlUserAvailabilityService {
  public constructor(
    private apollo: Apollo
  ) { }

  private calendarViewUserFragment = `
  user {
    id
    firstName
    lastName
    HomeAddress {
      id
      city
      state
      latitude
      longitude
    }
    Phones {
      number
      isPrimary
    }
    CertForCalView {
      id
      Type {
        id
        title
        state
        isRestriction
      }
    }
  }
  events
`;

public getUsersConnection(filters: IApiUserCalendarFilter[] = [], options: IGqlBaseOptions = {}): Observable<IApiUserCalendarsConnection> {
    const q = gql`${buildWithoutConnectionQuery("UserCalendarsConnection", "UserCalendar", "UserCalendarsConnection", this.calendarViewUserFragment)}`;
    return this.apollo.query(connectionQuery(q, filters, options)).pipe(
      safeResolve(true)
    );
  }


  public getUsersAvailability(userAvailabilityInput: IGqlUserAvailabilityInput): Observable<ScheduleInformation[]> {
    const q = gql`query availabilityByUsers($input: UserAvailabilityInput!) {
         availabilityByUsers(input: $input)
      }`;

    return this.apollo.query<IGqlUserAvailabilityResponse[]>({ query: q, variables: { input: userAvailabilityInput } }).pipe(
      safeResolve(true)
    );
  }
}
